import { Link, useLocation } from 'react-router-dom';
import ShellHeader from './ShellHeader';

/**
 * Shared 404 body — used on unknown routes and unknown `/games/:slug` (inside game shell).
 */
export function NotFoundContent({ variant = 'page' }) {
  const location = useLocation();
  const path = location.pathname || '/';

  return (
    <section
      className={`not-found${variant === 'game' ? ' not-found--game' : ''}`}
      aria-labelledby="not-found-heading"
    >
      <p className="not-found__code" aria-hidden="true">
        404
      </p>
      <h2 id="not-found-heading" className="not-found__title">
        Page not found
      </h2>
      <p className="not-found__lede">
        {variant === 'game'
          ? 'That mini-game is not on the hub yet (or the link is wrong).'
          : 'That URL is not part of Stans-World.'}
      </p>
      <p className="not-found__path" title={path}>
        {path}
      </p>
      <div className="not-found__actions">
        <Link className="not-found__btn not-found__btn--primary" to="/hub">
          Back to hub
        </Link>
        <Link className="not-found__btn" to="/games/paper-fly">
          Paper Fly
        </Link>
      </div>
    </section>
  );
}

/** Full-shell 404 for unmatched routes (same chrome as hub pages). */
export default function NotFoundPage() {
  return (
    <main className="page-view">
      <ShellHeader tab="notFound" />
      <NotFoundContent variant="page" />
    </main>
  );
}
